// extracted by mini-css-extract-plugin
export default {"container":"container_ScoreRow-module_au1Ip","fullWidth":"fullWidth_ScoreRow-module_PgnvT"};